export default "__VITE_ASSET__CwoiWUw2__"